export const MAP_ICONS = {
  station: () => new H.map.Icon('assets/icons/station.svg', {
    size: new H.math.Size(30, 30),
  }),
  selected_station: () => new H.map.Icon('assets/icons/map/selected_station.svg', {
    size: new H.math.Size(45, 45),
  }),
  rav_kav_station: () => new H.map.Icon('assets/icons/map/rav_kav_station.svg', {
    size: new H.math.Size(25, 25),
  }),
  park_and_ride: () => new H.map.Icon('assets/icons/map/park_and_ride.svg', {
    size: new H.math.Size(40, 40),
  }),
  park_and_ride_train: () => new H.map.Icon('assets/icons/map/park_and_ride_train.svg', {
    size: new H.math.Size(40, 40),
  }),
  route_edges_transit: () => new H.map.Icon('assets/icons/map/route_edges_transit.svg', {
    size: new H.math.Size(20, 20),
  }),
  location_circle_transit: () => new H.map.Icon('assets/icons/map/location_circle_transit.svg', {
    size: new H.math.Size(20, 20),
  }),
  selected_location_circle_transit: () => new H.map.Icon('assets/icons/map/selected_location_circle_transit.svg', {
    size: new H.math.Size(20, 20),
  }),
  location_circle_pedestrian: () => new H.map.Icon('assets/icons/map/location_circle_pedestrian.svg', {
    size: new H.math.Size(20, 20),
  }),

  pin_green: () => new H.map.Icon('assets/icons/map/destination.svg', {
    size: new H.math.Size(35, 45),
  }),

  my_location: () => new H.map.Icon('assets/icons/map/my_location_new.svg', {
    size: new H.math.Size(48, 48),
  }),

  on_map: () => new H.map.Icon('assets/icons/map/on_map.svg', {
    size: new H.math.Size(32, 32),
  }),
};
